import DashboardWrapper from "../components/layout/DashboardWrapper";

const SupportDocsPage: React.FC = () => {
    return (
        <DashboardWrapper>
            <div className="w-full flex flex-col gap-6 p-6 h-[calc(100vh-64px)] overflow-hidden">
                <h1 className="text-2xl font-heading mb-4">Support Documentation</h1>
                <p className="text-gray-700">
                    This is the Support Documentation page. Here you can manage and view all support-related documents.
                </p>
            </div>
        </DashboardWrapper>
    );
};

export default SupportDocsPage;